<template>
    <div class="goods-form">
        <veui-alert class="form-tip" status="info">
            曝光包需基于目标律师生效中的会员进行展示，请先对接您的运营了解可售卖的投放日期后进行下单
        </veui-alert>
        <veui-form
            ref="culeFormMember"
            :validators="validators"
            :data="formData"
        >
            <veui-field
                name="lawyer_name"
                label="目标律师"
                class="veui-field-required"
                :rules="[
                    {
                        name: 'required',
                        value: true,
                        message: '请选择目标律师',
                    },
                ]"
            >
                <lawyer-selector v-model="selectedLawyer"/>
            </veui-field>
            <veui-field
                name="city"
                label="目标城市"
                searchable
                :rules="[
                    {
                        name: 'required',
                        value: true,
                        message: '请选择目标城市',
                    },
                ]"
            >
                <veui-select
                    v-if="!selectedLawyer"
                    v-model="formData.city"
                    ui="l"
                    data-stat-ignore
                    clearable
                    placeholder="请选择目标城市"
                    searchable
                    @change="checkCityDomainRange"
                    @clear="clearCityDomainRange"
                >
                    <veui-option
                        v-for="(item, index) in regionOption"
                        :key="index"
                        :value="item.value + '|' + item.text"
                        :label="item.text"
                    />
                </veui-select>
                <span v-if="cityLevel && !selectedLawyer" class="form-icon">
                    <veui-icon name="building"/>
                    {{ cityLevelList[cityLevel] }}
                </span>
                <veui-input
                    v-if="selectedLawyer"
                    :value="
                        formData.city +
                            '(' +
                            cityLevelList[selectedLawyer.cityLevel] +
                            ')'
                    "
                    :readonly="true"
                ></veui-input>
            </veui-field>
            <veui-field
                name="domain"
                label="目标领域"
                searchable
                :rules="[
                    {
                        name: 'required',
                        value: true,
                        message: '请选择目标领域',
                    },
                ]"
            >
                <div class="range-box">
                    <div class="goods-form-num">
                        <div class="goods-form-num-input">
                            <veui-select
                                v-model="formData.domain"
                                ui="l"
                                data-stat-ignore
                                clearable
                                multiple
                                searchable
                                placeholder="请选择线目标领域"
                                @clear="clearCityDomainRange"
                                @change="domainChange"
                            >
                                <veui-option-group
                                    v-for="(item, index) in doaminOption"
                                    :key="index"
                                    :label="item.name"
                                    position="popup"
                                >
                                    <veui-option
                                        v-for="item in item.children"
                                        :key="item.id"
                                        :value="item.id"
                                        :label="item.name"
                                    />
                                </veui-option-group>
                            </veui-select>
                        </div>
                    </div>
                    <div
                        v-if="
                            cityLevel &&
                                curGoodsInfo &&
                                curGoodsInfo.city &&
                                curGoodsInfo.city[cityLevel]
                        "
                        class="tips"
                    >
                        <span>
                            请选择需要曝光的领域标签，¥{{
                                (curGoodsInfo.city[cityLevel] *
                                    curGoodsInfo.discount) /
                                    1000
                            }}元/个，{{
                                curGoodsInfo.discount !== 10 &&
                                    curGoodsInfo.discount_txt
                                    ? curGoodsInfo.discount_txt + ","
                                    : ""
                            }}3个标签起购
                        </span>
                    </div>
                </div>
            </veui-field>
            <veui-field
                name="newRange"
                label="投放日期"
                :rules="[
                    {
                        name: 'required',
                        value: true,
                        message: '请选择投放日期',
                    },
                ]"
            >
                <div class="range-box">
                    <!-- 新时间选择器，按星期排列，整齐规划 -->
                    <div class="new-date-selected">
                        <veui-select
                            v-model="formData.newRange"
                            ui="l"
                            placeholder="请选择投放日期"
                            clearable
                            overlay-class="rule-date-selected"
                        >
                            <veui-option-group
                                v-for="(item, index) in weeksData"
                                :key="index"
                                :label="item.month"
                                position="popup"
                            >
                                <veui-option
                                    v-for="item in item.week"
                                    :key="item.label"
                                    :value="item.label"
                                    :label="item.label"
                                />
                            </veui-option-group>
                            <div
                                v-if="weeksData.length"
                                slot="after"
                                class="new-date-box"
                            >
                                <div class="new-date-title">可选时间列表</div>
                                <div class="new-date-sub-title">
                                    以下为
                                    <span class="new-date-sub-title-bold">{{
                                        selectedLawyer
                                            ? formData.city
                                            : currentCity
                                    }}</span>
                                    <span class="new-date-sub-title-bold">{{
                                        currentDomain
                                    }}</span>
                                    可投放时间，仅支持选择自然周投放
                                </div>
                                <div class="new-date-month-selected">
                                    <div
                                        v-for="(item, index) in weeksData"
                                        :key="index"
                                        class="new-date-month-selected-item"
                                        :class="
                                            currentMonth === index
                                                ? 'new-date-month-selected-item-action'
                                                : ''
                                        "
                                        @click="monthSelected(index)"
                                    >
                                        <div
                                            class="new-date-month-selected-item-month"
                                        >
                                            {{ item.month }}
                                        </div>
                                        <div
                                            v-if="
                                                item.available &&
                                                    item.available > 0
                                            "
                                            class="new-date-month-selected-item-status"
                                        >
                                            {{ item.available }}周可投
                                        </div>
                                        <div
                                            v-else
                                            class="new-date-month-selected-item-status"
                                        >
                                            已投满
                                        </div>
                                        <div
                                            class="new-date-month-selected-item-line"
                                        ></div>
                                    </div>
                                </div>
                                <div class="new-date-weeks-selected">
                                    <div
                                        v-for="(
                                            weekItem, index
                                        ) in currentMonthWeeks"
                                        :key="index"
                                        class="new-date-weeks-selected-item"
                                        :class="
                                            weekItem.is_available === '1'
                                                ? formData.newRange ===
                                                    weekItem.label
                                                    ? 'item-action'
                                                    : ''
                                                : 'item-disabled'
                                        "
                                        @click="newDateClick(weekItem)"
                                    >
                                        {{ weekItem.label }}
                                    </div>
                                </div>
                            </div>
                            <div
                                v-else slot="after"
                                class="new-not-date-box"
                            >
                                <img
                                    src="https://lvlin-base.cdn.bcebos.com/bend/weeks-not-use.png"
                                    class="new-not-date-box-img"
                                />
                                <div
                                    v-if="
                                        !formData.city ||
                                            !formData.domain ||
                                            !formData.domain.length
                                    "
                                    class="new-date-sub-title"
                                >
                                    您还未选择城市或者领域标签，请先行选择城市和领域标签再选择日期。
                                </div>
                                <div
                                    v-else-if="formData.domain.length < 3"
                                    class="new-date-sub-title"
                                >
                                    您还未选择足够领域标签，请至少选择三个领域标签。
                                </div>
                                <div v-else class="new-date-sub-title">
                                    <span class="new-date-sub-title-bold">{{
                                        selectedLawyer
                                            ? formData.city
                                            : currentCity
                                    }}</span>
                                    <span class="new-date-sub-title-bold">{{
                                        currentDomain
                                    }}</span>
                                    领域近期投放排期已售罄，您可选择其他领域或减少标签
                                </div>
                            </div>
                        </veui-select>
                    </div>
                    <div class="tips">
                        支付后将以该日期0点为起始投放时间，7天后（含投放开始日）24点结束投放
                    </div>
                </div>
            </veui-field>
            <veui-field
                name="isAgree"
                label=""
                :rules="[
                    {
                        name: 'required',
                        trigger: 'change',
                        value: true,
                        message: '请阅读并勾选协议',
                    },
                ]"
            >
                <veui-checkbox v-model="formData.isAgree" :false-value="null">
                    我已阅读并同意<span
                        class="goods-form-rule"
                        @click.stop="openRule"
                    >《{{ agreementInfo.name }}》</span>
                </veui-checkbox>
            </veui-field>
        </veui-form>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 律临曝光增量包
 * @author
 */

import {
    Form,
    Field,
    Select,
    Input,
    Option,
    Checkbox,
    Icon,
    OptionGroup,
    Alert
} from 'veui';
import isBoolean from 'lodash/isBoolean';
import 'veui-theme-dls-icons/exclamation-circle';
import 'veui-theme-dls-icons/building';
import 'veui-theme-dls-icons/tag';
import {mapState} from 'vuex';
import LawyerSelector from '@/components/firm/lawyer-selector';

const url = {
    vipbuyprice: 'law:/themis/law/commodity/vipbuyprice',
    buycode: '/bp/api/product/vip_buy_code',
    clueQuerySelect: 'law:/themis/law/commodity/clue_queryselect',
    clueOrderlist: 'law:/themis/law/commodity/orderlist',
    domain: '/bp/api/lawyer/get_lawyer_domain',
    cityList: '/bp/api/city/citylist',
    checkCityDomain: '/bp/api/product/brand_exposure_info'
};
export default {
    name: 'goodsForm',
    props: {
        goodsList: {
            type: Object,
            default: () => {}
        },
        goodsForm: {
            type: Object,
            default: () => {}
        },
        goodsOrder: {
            type: Object,
            default: () => {}
        },
        agreementInfo: {
            type: Object,
            default: () => {}
        },
        goodsInfo: {
            type: Object,
            default: () => {}
        },
        channel: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            numRule: [
                {
                    name: 'required',
                    value: true,
                    message: '请输入线索数量',
                    triggers: 'change'
                }
            ],
            formData: {},
            validators: [
                {
                    fields: ['domain'],
                    validate(domain) {
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                if (!domain || domain.length < 3) {
                                    res = {
                                        domain: '至少选择三个领域标签'
                                    };
                                }
                                return resolve(res);
                            });
                        });
                    }
                }
            ],
            cityLevelList: {
                FIRST_CITY: '一级城市',
                SECOND_CITY: '二级城市',
                THIRD_CITY: '三级城市'
            },
            regionOption: [],
            doaminOption: [],
            weeksData: [], // 可选择的星期数据
            currentMonth: 0, // 当前所在的月份
            selectedLawyer: null
        };
    },
    computed: {
        ...mapState({
        }),
        curGoodsInfo() {
            return this.goodsInfo?.cpt_vip || {};
        },
        cityLevel() {
            const cityData
                = (this.formData.city && this.formData.city.split('|')) || [];
            const currentCity = this.regionOption.filter(
                item => '' + item.value === cityData[0]
            );
            return currentCity && currentCity[0] && currentCity[0].level;
        },
        // 当前所选择月的星期数据
        currentMonthWeeks() {
            return (
                (this.weeksData
                    && this.weeksData[this.currentMonth]
                    && this.weeksData[this.currentMonth].week)
                || []
            );
        },
        // 当前所选择的城市
        currentCity() {
            const cityData
                = (this.formData.city && this.formData.city.split('|')) || [];
            return (cityData && cityData[1]) || '';
        },
        // 当前所选择的领域
        currentDomain() {
            const cityData = this.formData.domain;
            const doaminOption = this.doaminOption;
            let domainLabel = '';
            doaminOption.map(item => {
                item.children
                    && item.children.map(childrenItem => {
                        cityData.includes(childrenItem.id)
                            && (domainLabel += childrenItem.name + '、');
                        return childrenItem;
                    });
                return item;
            });
            domainLabel = domainLabel.substring(0, domainLabel.length - 1);
            return domainLabel || '';
        }
    },
    watch: {
        selectedLawyer(newVal) {
            const lawyer = newVal || {};
            const cityName = lawyer.cityName?.split('$') || [];
            const city = lawyer.city?.split('$') || [];
            this.formData.lawyer_name = lawyer.name;
            this.formData.qc_core_no = lawyer.qc_core_no;
            this.formData.city = cityName[cityName.length - 1];
            this.formData.cityCode = city[city.length - 1];
            this.domainChange(this.formData.domain || []);
            this.$refs.culeFormMember.validate();
        }
    },
    components: {
        'veui-icon': Icon,
        'veui-form': Form,
        'veui-field': Field,
        'veui-select': Select,
        'veui-option': Option,
        'veui-checkbox': Checkbox,
        'veui-input': Input,
        'veui-option-group': OptionGroup,
        'veui-alert': Alert,
        'lawyer-selector': LawyerSelector
    },
    mounted() {
        this.getCity();
        this.getDomain();
    },
    filters: {
        cityNameCol(value) {
            const cityName = (value && value.split('$')) || [];
            return (cityName && cityName[cityName.length - 1]) || '-';
        }
    },
    methods: {
        // 新版本日期点击选择
        newDateClick(week) {
            if (week.is_available !== '1') {
                return;
            }
            this.formData = {
                ...this.formData,
                newRange: week.label,
                newRangeValue: week.value
            };
            this.newDateTimeout = setTimeout(() => {
                this.$refs.culeFormMember.validate();
                clearTimeout(this.newDateTimeout);
                this.newDateTimeout = null;
            }, 500);
        },
        // 切换月份
        monthSelected(index) {
            this.currentMonth = index;
        },
        // 清空新日期选择的内容
        clearCityDomainRange() {
            this.weeksData = [];
            this.formData = {
                ...this.formData,
                newRange: null,
                newRangeValue: null
            };
        },
        domainChange(value) {
            if (!value || value.length < 3) {
                this.clearCityDomainRange();
            }
            else {
                this.checkCityDomainRange();
            }
        },
        // 选择城市和领域之后请求日期数据
        checkCityDomainRange() {
            setTimeout(() => {
                const {city, domain} = this.formData;
                if (!city || !domain || !domain.length) {
                    this.clearCityDomainRange();
                    return;
                }
                const cityData = city.split('|');
                this.$http
                    .get(url.checkCityDomain, {
                        params: {
                            city_code: this.selectedLawyer
                                ? this.formData.cityCode
                                : cityData[0],
                            domain: (domain && domain.join(',')) || ''
                        }
                    })
                    .then(resp => {
                        this.weeksData = resp.data;
                    });
            }, 500);
        },
        dateCheck: function (time) {
            const nowTime = new Date();
            const oldTime = new Date(time);
            const over = (oldTime - nowTime) / (1000 * 60 * 60 * 24);
            return (
                over < 0
                || oldTime - new Date('2022-12-22'.replace(/-/g, '/')) > 0
            );
        },
        getCity() {
            this.$http
                .get(url.cityList)
                .then(resp => {
                    if (!resp || +resp.code !== 0) {
                        return;
                    }
                    const data = resp?.data;
                    if (data) {
                        this.regionOption = data || [];
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        },
        getDomain() {
            this.$http
                .get(url.domain)
                .then(resp => {
                    const data = this.$normalizeResponseData(resp);
                    if (data) {
                        this.doaminOption = data || [];
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        },
        sumbitForm() {
            this.$refs.culeFormMember.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    this.postData();
                }
                else {
                    const toast = {
                        content: '请完成必填选项',
                        duration: 3
                    };
                    this.$Message.info(toast);
                    this.$emit('nextStep', false);
                }
            });
        },
        postData() {
            const {formData} = this;
            const cityData = this.selectedLawyer
                ? [formData.cityCode, formData.city]
                : this.formData.city.split('|');
            const start_time = formData.newRangeValue;
            let postParams = {
                city: cityData[0],
                city_name: cityData[1],
                domian_ids_name: this.currentDomain,
                qc_core_no: formData.qc_core_no,
                domain_fields_ids:
                    (this.formData.domain && this.formData.domain.join(','))
                    || '',
                lawyer_name: this.selectedLawyer.name,
                lawyer_phone: this.selectedLawyer.phone,
                agreement_ids: this.agreementInfo.id,
                num: 1,
                code_type: 4,
                start_time: '' + start_time // 下单时间
            };
            this.$http
                .post(url.buycode, {
                    ...postParams,
                    params: JSON.stringify(postParams)
                })
                .then(resp => {
                    const data = resp.data;
                    if (data) {
                        const {
                            discount_amount,
                            should_pay_amount,
                            total_amount,
                            city_level,
                            domain_fields_price
                        } = data.product_info;
                        const {domain, lawyer_phone, start_time}
                            = data.goodsInfo;
                        const order = {
                            city:
                                cityData[1]
                                + (city_level
                                    ? '(' + this.cityLevelList[city_level] + ')'
                                    : ''),
                            lawyer:
                                postParams.lawyer_name
                                + (lawyer_phone ? '(' + lawyer_phone + ')' : ''),
                            domain: domain,
                            range: start_time,
                            servicePrice:
                                '￥'
                                + domain_fields_price / 100
                                + '/每个领域'
                                + (city_level
                                    ? ',('
                                        + this.cityLevelList[city_level]
                                        + ')'
                                    : ''),
                            totalAmount: '￥' + total_amount / 100,
                            discountAmount: '￥' + discount_amount / 100,
                            shouldPayAmount: '￥' + should_pay_amount / 100,
                            pay_url: data.order_info.order_info_url
                        };
                        this.$emit('setGoodsFn', 'goodsOrder', order);
                        this.$emit('nextStep', true);
                    }
                    else {
                        const toast = {
                            content: resp.msg,
                            duration: 3
                        };
                        this.$Message.info(toast);
                        this.$emit('nextStep', false);
                    }
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.$emit('nextStep', false);
                });
        },
        openRule() {
            window.open(this.agreementInfo.url);
        },
        getOrderInfo(orderId) {
            const params = {
                order_status: '',
                begin_time: '',
                end_time: '',
                pn: 1,
                rn: 10,
                tp_oid: orderId
            };
            this.$http
                .get(url.clueOrderlist, {
                    params
                })
                .then(resp => {
                    const data = resp?.data?.data || {};
                    if (data && data.data && data.data.list.length) {
                        const {
                            label_amount = null,
                            city_level = 'FIRST_CITY',
                            product_num = null
                        } = data.data.list[0];
                        this.$nextTick(() => {
                            this.formData = {
                                ...this.formData,
                                city_level: city_level,
                                num: product_num,
                                domain_fields_num: label_amount
                            };
                        });
                    }
                })
                .catch(err => this.$normalizeResponseError(err));
        }
    }
};
</script>

<style scoped lang="less">
.goods-form {
    .form-tip {
        font-size: 16px;
        margin-bottom: 10px;
    }

    margin-bottom: -24px;

    .selected-lawyer {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #000;
        line-height: 14px;
        font-weight: 400;

        span {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #404eff;
            line-height: 14px;
            font-weight: 400;
            cursor: pointer;
        }
    }

    .goods-form-num {
        display: block;

        &-tip {
            height: 32px;
            color: #282c33;
            line-height: 32px;
        }

        &-text {
            margin-top: 8px;
            color: #848b99;
        }

        &-icon {
            font-size: 14px;
            width: 14px;
            height: 14px;
            color: #848b99;
        }

        /deep/ .veui-input[ui~="l"] {
            height: auto;
            min-height: 40px;
        }
    }

    /deep/ .veui-button {
        color: #999;
    }

    /deep/ .veui-date-picker-trigger {
        height: 36px;
    }

    /deep/ .veui-field-label {
        width: calc(5em + 6px);
    }

    .veui-field-no-label {
        margin-left: 12px;
    }

    .goods-form-rule {
        color: #0052cc;
    }

    /deep/ .clue-city-radio > .veui-radio-box {
        display: none;
    }

    .form-icon {
        cursor: pointer;
        color: #282c33;
        margin-left: 12px;
    }

    .veui-date-picker {
        width: 300px;
    }

    .range-box {
        position: relative;

        .range-box-tip {
            position: absolute;
            left: 300px;
            top: 0;
            width: 500px;
            padding-left: 24px;
        }
    }
}

.veui-overlay-box .new-date-box {
    width: 336px;
    background: #fff;
    box-shadow: 0 3px 8px 0 rgba(215, 220, 233, .55);
    box-shadow: 0 1px 1px 0 rgba(199, 206, 223, .07);
    border-radius: 8px;
    padding-top: 14px;
    padding-bottom: 24px;

    .new-date-title {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #000;
        line-height: 16px;
        font-weight: 500;
        padding: 0 24px;
    }

    .new-date-sub-title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: 400;
        margin-top: 12px;
        padding: 0 24px;
    }

    .new-date-sub-title-bold {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: 600;
        margin-top: 12px;
    }

    .new-date-month-selected {
        width: 100%;
        border-bottom: 1px solid #e9ecf3;
        margin-top: 22px;
        padding: 0 24px;
        display: flex;
        overflow: scroll;

        .new-date-month-selected-item {
            width: 80px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            padding-bottom: 11px;
            margin-right: 35px;
            cursor: pointer;

            &:last-child {
                margin-right: 0;
            }

            .new-date-month-selected-item-month {
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #000;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 4px;
            }

            .new-date-month-selected-item-status {
                font-family: PingFangSC-Regular;
                font-size: 10px;
                color: #9d9d9d;
                line-height: 10px;
                font-weight: 400;
                transform: scale(.8);
            }

            .new-date-month-selected-item-line {
                width: 100%;
                height: 2px;
                background: #404eff;
                border-radius: 2px;
                position: absolute;
                left: 0;
                bottom: 0;
                display: none;
            }
        }

        .new-date-month-selected-item-action {
            .new-date-month-selected-item-month {
                color: #404eff;
            }

            .new-date-month-selected-item-status {
                color: #404eff;
            }

            .new-date-month-selected-item-line {
                display: block;
            }
        }
    }

    .new-date-weeks-selected {
        width: 100%;
        padding: 0 24px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 3px;

        .new-date-weeks-selected-item {
            min-width: 140px;
            height: 38px;
            background: #f6f8f9;
            border-radius: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(0, 0, 0, .8);
            text-align: center;
            line-height: 14px;
            font-weight: 400;
            margin-top: 8px;
            cursor: pointer;
        }

        .item-disabled {
            background: #fff;
            color: rgba(0, 0, 0, .2);
        }

        .item-action {
            background: #404eff;
            color: #fff;
        }
    }

    /deep/ .veui-option-group {
        display: none;
    }
}

.veui-overlay-box .new-not-date-box {
    width: 336px;
    background: #fff;
    box-shadow: 0 3px 8px 0 rgba(215, 220, 233, .55);
    box-shadow: 0 1px 1px 0 rgba(199, 206, 223, .07);
    border-radius: 8px;
    padding-top: 68px;
    padding-bottom: 48px;

    .new-not-date-box-img {
        width: 119px;
        height: 77px;
        display: block;
        margin: 0 auto 32px;
    }

    .new-date-title {
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #000;
        line-height: 16px;
        font-weight: 500;
        padding: 0 24px;
    }

    .new-date-sub-title {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: 400;
        margin-top: 12px;
        padding: 0 24px;
    }

    .new-date-sub-title-bold {
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: 600;
        margin-top: 12px;
    }
}

.tips {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #9d9d9d;
    line-height: 12px;
    font-weight: 400;
    margin-top: 12px;
}

/deep/ .veui-tabs-menu {
    width: 300px;
    height: 30px;
}

/deep/ .veui-tabs[ui~="l"] .veui-tabs-menu {
    height: 30px;
}

.end-time {
    color: #fa6400;
}
</style>
<style lang="less">
.rule-date-selected {
    .veui-select-options[ui~="m"] {
        max-height: 500px;
        border: 1px solid rgba(233, 236, 243, 1);
    }

    .veui-option-group {
        display: none;
    }
}
</style>
